<template>
    <div class="d-flex align-center justify-space-between px-6 pt-4">
        <div class="text-h6 medium">
            {{ translate('common.payout_details') }}
        </div>
        <div class="text-caption text-no-wrap">2 / 2</div>
    </div>
    <div class="text-subtitle-2 px-6 pt-2">{{ translate('common.payout_details_text') }}</div>
    <div class="px-6 pt-6">
        <TextField
            v-model:input="internal_clearing_number"
            v-model:valid="internal_is_clearing_number_valid"
            :hint="translate('common.number_of_digits', ['4-5'])"
            :label="translate('common.clearing_number')"
            :rules="[(v) => validate_clearing_number(v)]"
            class="mb-4"
            type="number"
        />
        <TextField
            v-model:input="internal_account_number"
            v-model:valid="internal_is_account_number_valid"
            :hint="translate('common.number_of_digits', ['5-15'])"
            :label="translate('common.account_number')"
            :rules="[(v) => validate_account_number(v)]"
            type="number"
        />
    </div>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'
import { rules_mixin } from '@old/mixins/rules_mixin'
import TextField from '@old/components/input/TextField.vue'

export default {
    name: 'ProfileDialogBankAccountInfo',
    props: {
        clearing_number: {
            type: String,
        },
        is_clearing_number_valid: {
            type: Boolean,
        },
        account_number: {
            type: String,
        },
        is_account_number_valid: {
            type: Boolean,
        },
    },
    mixins: [locales_mixin, rules_mixin],
    components: { TextField },
    emits: [
        'update:clearing_number',
        'update:is_clearing_number_valid',
        'update:account_number',
        'update:is_account_number_valid',
    ],
    data() {
        return {}
    },
    computed: {
        internal_clearing_number: {
            get() {
                return this.clearing_number
            },
            set(value) {
                this.$emit('update:clearing_number', value)
            },
        },
        internal_is_clearing_number_valid: {
            get() {
                return this.is_clearing_number_valid
            },
            set(value) {
                this.$emit('update:is_clearing_number_valid', value)
            },
        },
        internal_account_number: {
            get() {
                return this.account_number
            },
            set(value) {
                this.$emit('update:account_number', value)
            },
        },
        internal_is_account_number_valid: {
            get() {
                return this.is_account_number_valid
            },
            set(value) {
                this.$emit('update:is_account_number_valid', value)
            },
        },
    },
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
